import PinRecoveryModal from "components/settings/pin-recovery-modal/PinRecoveryModal";
import ThemeContext from "config/context/themeContext";
import { useContext, useState } from "react";
import styles from "../Settings.module.css";

const GeneralSettings = () => {
  const tooltipNotification = "This feature is coming soon";

  const { changeTheme, dark } = useContext(ThemeContext);
  const [isRecoveryModalOpen, setIsRecoveryModalOpen] = useState(false);

  return (
    <section className={styles.generalSettings}>
      <div className={styles.settingsContainer}>
        <div onClick={() => setIsRecoveryModalOpen(true)}>
          <img
            src={`../img/settings/change-pin-icon${dark ? "-dark" : ""}.svg`}
            alt="changepin"
          />
          Change PIN
        </div>
        <div onClick={() => changeTheme()}>
          <img
            src={`../img/settings/${dark ? "sun-dark" : "moon"}.svg`}
            alt="theme"
          />
          Theme
        </div>
        <div data-tooltip={tooltipNotification}>
          <img
            src={`../img/settings/language${dark ? "-dark" : ""}.svg`}
            alt="language"
          />
          Language
        </div>
        {/* <div><img src="../img/settings/key.svg" alt="" /> Remember Private Key</div> */}
      </div>

      <PinRecoveryModal
        isRecoveryModalOpen={isRecoveryModalOpen}
        setIsRecoveryModalOpen={setIsRecoveryModalOpen}
      />
    </section>
  );
};

export default GeneralSettings;
